<template>
    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 shape-primary shape-skew">
            </div>
            <div class="container shape-container pt-lg pb-300">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-7">
                        <h2 class="text-white display-1 pb-2 d-none d-sm-block">Estúdios de Dublagem</h2>
                        <estudio-search-form></estudio-search-form>
                    </div>
                </div>
            </div>
        </section>
        <estudio-card-deck classes="mt--300 pt-4" pagination></estudio-card-deck>
    </div>
</template>
<script>
import EstudioSearchForm from '@/layout/components/Catalog/EstudioSearchForm';
import EstudioCardDeck from "@/layout/components/Catalog/EstudioCardDeck";

export default {
    components: {
        EstudioSearchForm, EstudioCardDeck
    }
};
</script>
<style>
    h2.display-1 {
        line-height: 1;
    }
</style>
